import React from 'react';

import { QuestionCircleFilled as HelpIcon, QuestionCircleOutlined as HelpOutlineIcon } from '@ant-design/icons';
import { Tooltip } from 'antd';
import type { TooltipPlacement } from 'antd/es/tooltip';

interface IProps {
  text: React.ReactNode;
  placement?: TooltipPlacement;
  isNew?: boolean;
}

const HelpTip = ({ text, placement = 'top', isNew }: IProps) => {
  const helpIconClass = `text-[18px] ${isNew ? 'text-grey-500!' : 'text-[#B0BEC5]!'}`;

  return (
    <Tooltip title={text} placement={placement}>
      {!!isNew ? <HelpOutlineIcon className={helpIconClass} /> : <HelpIcon className={helpIconClass} />}
    </Tooltip>
  );
};

export default HelpTip;
